import { createFileRoute, redirect } from "@tanstack/react-router"
import { SigninVerificationPage } from "@/pages/onboarding"

interface SigninVerificationSearch {
	email?: string | undefined
}

export const Route = createFileRoute("/onboarding/signin-verification")({
	component: SigninVerificationPage,
	validateSearch: (search): SigninVerificationSearch => ({
		email: typeof search.email === "string" ? search.email : undefined,
	}),
	beforeLoad: ({ search }) => {
		if (!search.email) throw redirect({ to: "/onboarding/signin-email" })
		return { email: search.email }
	},
})
